import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Header } from 'pages/Header';
import { Footer } from 'pages/Footer';
import { BASE_PATH, SUB_DIRECTORY } from 'constants/general';
import "./style.sass";
import { useServices } from 'hooks/useServices';
import { useIsMobile } from 'hooks/useIsMobile';
import SlidersEmarsys from 'components/Emarsys/SlidersEmarsys/index_product';
import HeaderMobileCredito from 'components/Header/HeaderMobileCredito';
import { useHomePage } from 'hooks/useHomePage';
import { InputTypeAndroid } from 'components/Forms/InputType';
import { useForm } from 'react-hook-form';
import getTelmexStatus from 'services/getTelmexStatus';
import { ModalError } from 'components/Error/ErrorModal';
import { decodeStorage } from 'functions/storageBase64';
import { postClaroScore } from 'services/claroScore';
import getShipping from 'services/getShipping';
import { ClasicSelectTypeNew } from 'components/Forms/Select';
import { ProgressBar } from 'components/ProgressBar';
import { useStorage64 } from 'hooks/useStorageBase64';
import { estadosAbreviacion } from 'constants/variables';
import {ModalLoadingCredit} from 'components/Loading';
import { PantallaError500 } from 'pages/NuevoCredito/MensajesErrores/pantallaError500';


export function DireccionIncode() {

    const history = useHistory();
    const [ loading, setLoading ] = useState(false);
    //variables para modal de error
    const [errorCode, setErrorCode] = useState();
    const [messageResponse, setMessageResponse] = useState();
    const [sectionActive, setSectionActive] = useState("");
    const [showModalErr, setShowModalErr] = useState(false);

    const EXTERNO = decodeStorage('EXTERNO');

    // valida respuesta del servicio y si no pasa manda el error
    const handleCloseErr = () => {
        setShowModalErr(false);
        if (sectionActive === 'verificar') {
            window.location.href = `${BASE_PATH}`;
        }
    }

    //- Codigo de instana para track de pagina 
    useEffect(() => {
        window.scrollTo(0, 0);
        window.ineum('page', 'Direccion  Credit-Page');
        window.ineum('meta', 'portal', 'Credito CS');
    }, [])

    const datosPersonalesStorage = decodeStorage("infoPersonalStorageIncode")
    const [datosPersonales, setDatosPersonales] = useState(datosPersonalesStorage);

    const [, setInfoDireccionStorage] = useStorage64('infoDireccionStorage', '');

    const [shipping, setShupping] = useState({});
    const [inputCalle, setInputCalle] = useState();
    const [inputCP, setInputCP] = useState(datosPersonales?.addresFields?.postalCode);
    const [estado, setEstado] = useState();
    const [estadoEnDos, setEstadoEnDos] = useState("");
    const [municipio, setMunicipio] = useState();
    const [ciudad, setCiudad] = useState();
    const [colonia, setColonia] = useState();
    const [inputAnioResidencia, setInputAnioResidencia] = useState();
    const [inputMesesResidencia, setInputMesesResidencia] = useState();
    /* const [abreviacionEstadoRes, setAbreviacionEstadoRes] = useState(false);
    const [activarCP,setActivarCP] = useState(false);

    const [vecesIngresadasCP, setVecesIngresadasCP] = useState(1); */

    const { register, handleSubmit, errors, clearErrors, reset } = useForm({
        defaultValues: { 
            calle: datosPersonales?.addresFields?.street,
            cp: datosPersonales?.addresFields?.postalCode,
            colonia: datosPersonales?.addresFields?.colony,
            municipio: datosPersonales?.addresFields?.city,
            estado: datosPersonales?.addresFields?.state,
            ciudad:  datosPersonales?.addresFields?.state,
            anioResidencia: "",
            mesesResidencia: ""
        }
    })

    const valCalle = {
        required: 'Campo obligatorio',
    };
    const valCp = {
        required: 'Campo obligatorio',
        minLength: {
            value: 5,
            message: 'Faltan dígitos. Deben ser 5 dígitos'
        },
        maxLength: {
            value: 5,
            message: 'No debe contener más de 5 dígitos'
        },
        pattern: {
            value: /[0-9]{0,99999}/,
            message: 'El formato de CP es inválido'
        }
    };
    const valColonia = {
        required: 'Campo obligatorio',
        minLength: {
            value: 1,
            message: 'El estado es requerido'
        },
        maxLength: {
            value: 120,
            message: 'La colonia debe tener un máximo de 120 caracteres'
        }
    };
    const valMunicipio = {
        required: 'Campo obligatorio',
    };
    const valEstado = {
        required: 'Campo obligatorio',
    };
    const valCiudad = {
        required: 'Campo obligatorio',
    };
    const valAnioRes = {
        required: 'Campo obligatorio'
    }
    const valMesRes = {
        required: 'Campo obligatorio',
        max: {
            value: 11,
            message: 'La cantidad máxima de meses que puede tener este campo son 11'
        }
    }
    

     // si el formulario es correcto se guarda al storage
     const handleInformacionIne = data => {
        
        console.log("data form",data);

        setInfoDireccionStorage({
            "Domicilio": data.calle,
            "CP": data.cp,
            "Colonia": data.colonia,
            "Municipio": data.municipio,
            "Estado": estadoEnDos,
            "Ciudad": data.ciudad,
            "TiempoResAnio": data.anioResidencia,
            "TiempoResMes": data.mesesResidencia
        })

        history.push(`${BASE_PATH}${SUB_DIRECTORY}ultimos-pasos-ocupacion`)
    }

    /* useEffect(() => {
        console.log("postalCode?.length",datosPersonales?.addresFields?.postalCode)
        if(datosPersonales?.addresFields?.postalCode?.length === 5){
            console.log("SI PASA")
            setActivarCP(true);
            setLoading(true); 
            getShipping({ codigoPostal: datosPersonales?.addresFields?.postalCode })
            .then(setShupping);
        }

    },[])

    useEffect(() => {
        if (abreviacionEstadoRes) { 
            if(abreviacionEstadoRes?.code === 200){
                let resultado = [];
                estadosAbreviacion.map((ele) =>
                    ele?.completo === String(abreviacionEstadoRes?.estado).toLowerCase()
                        ? resultado.push(ele?.inicial)
                        : null//resultado.push(data.estado)
                )

                // setea estado ejem: Aguascalientes -> AG
                setEstadoEnDos(resultado[0]);
                console.log("ESTADO DOS abreviacionEstadoRes", resultado[0]);
                setLoading(false); 
            }else if(abreviacionEstadoRes?.code === 404){
                setLoading(false); 
                setShowModalErr(true);
                setErrorCode(abreviacionEstadoRes?.code);
                setSectionActive('cp');
                setMessageResponse(abreviacionEstadoRes?.error);
            }else if(abreviacionEstadoRes?.error >= 500){
                setLoading(false); 
                setErrorCode(abreviacionEstadoRes?.error);
            }

        }
    }, [abreviacionEstadoRes])*/


    // llenado de campos con cp
    useEffect(() => {
        if (inputCP) {
            //loading
            if(inputCP?.length === 5){
                //setVecesIngresadasCP((prev) => prev + 1);
                //console.log("vecesIngresadasCP",vecesIngresadasCP)
                //if(vecesIngresadasCP >= 2 || !datosPersonales?.addresFields?.postalCode){
                    setLoading(true); 
                    getShipping({ codigoPostal: inputCP })
                    .then(setShupping);
                //}
            }
            else if (inputCP?.length < 5 || inputCP?.length === 0) {
                setEstado('');
                setMunicipio('');
                setCiudad('');
                setColonia([]);
            }
        }
    }, [inputCP])

    useEffect(() => {
        if (shipping) {
            if(shipping?.code === 200){
                setLoading(false); 
                setEstado(shipping?.estado);
                setMunicipio(shipping?.municipio);
                setCiudad(shipping?.ciudad);

                clearErrors('estado');
                clearErrors("ciudad");
                clearErrors("colonia");
                clearErrors("municipio");

                let resultado = [];
                estadosAbreviacion.map((ele) =>
                    ele?.completo === String(shipping?.estado).toLowerCase()
                        ? resultado.push(ele?.inicial)
                        : null//resultado.push(data.estado)
                )
                //recabamos el dato de la abreviacion estado si el ocr tiene cp
                // setea estado ejem: Aguascalientes -> AG
                setEstadoEnDos(resultado[0]);
                //console.log("ESTADO DOS", resultado[0]);

                if (shipping?.colonias) {
                    if (shipping?.colonias?.length === 0) {
                        setColonia([]);
                    }
                    else if (shipping?.colonias?.length >= 1) {
                        setColonia(shipping.colonias);
                    }
                }
            }else if(shipping?.code === 404){
                setLoading(false); 
                setShowModalErr(true);
                setErrorCode(shipping?.code);
                setSectionActive('cp');
                setMessageResponse(shipping?.error);
            }else if(shipping?.error >= 500){
                setLoading(false); 
                setErrorCode(shipping?.error);
            }
        }
    }, [shipping])




    return (
        <>
            { loading && <ModalLoadingCredit /> }
            {errorCode >= 500
                ? <PantallaError500 />
                :<div className="modalCredito full">
                    <div className="contentModal">
                    {
                        EXTERNO ? null : <HeaderMobileCredito title="Solicitud de Crédito Claroshop" type="back" />
                    }
                        <div className="contenedorGeneral top0">
                            <div className="boxSolicitud">
                            <form onSubmit={handleSubmit(handleInformacionIne)} className="formularioSolicitudMobile">
                                <div className="tituloFormulariosMobile">
                                    <p>Dirección</p>
                                </div>
                                <>
                                    <div className="divFormMobile">
                                        <InputTypeAndroid
                                            type="text"
                                            id="calle"
                                            name="calle"
                                            placeholder="Calle y número"
                                            className="desktopInput"
                                            errorMessage={errors.calle && errors.calle.message}
                                            refs={register(valCalle)}
                                            pattern={'textOnly'}
                                            setNumero={setInputCalle}
                                            // value={inputCalle}
                                            numero={inputCalle}
                                            maxLength={30}
                                        />
                                    </div>

                                    <div className="divFormMobile">
                                        <InputTypeAndroid
                                            type="text"
                                            id="cp"
                                            name="cp"
                                            placeholder="Código Postal"
                                            className="desktopInput"
                                            errorMessage={errors.cp && errors.cp.message}
                                            refs={register(valCp)}
                                            pattern={'number'}
                                            maxLength={5}
                                            setNumero={setInputCP}
                                            // value={inputCP}
                                            numero={inputCP}
                                        />
                                    </div>

                                    <div className="divFormMobile">
                                        {colonia && colonia?.length >= 2
                                            ?
                                            <ClasicSelectTypeNew
                                                type="text"
                                                name="colonia"
                                                id="colonia"
                                                placeholder="Colonia"
                                                options={colonia}
                                                errorMessage={!colonia && (errors.colonia && errors.colonia.message)}
                                                refs={register(valColonia)}
                                                className="desktopInput"
                                            />
                                            : <InputTypeAndroid
                                                type="text"
                                                name="colonia"
                                                id="colonia"
                                                placeholder="Colonia"
                                                refs={register(valColonia)}
                                                value={colonia}
                                                readonly="readonly"
                                                errorMessage={!colonia && (errors.colonia && errors.colonia.message)}
                                                className="desktopInput"
                                            />
                                        }
                                    </div>

                                    <div className="divFormMobile">
                                        <InputTypeAndroid
                                            type="text"
                                            id="municipio"
                                            name="municipio"
                                            autocomplete="municipio"
                                            placeholder="Municipio"
                                            className="desktopInput"
                                            errorMessage={!municipio && (errors.municipio && errors.municipio.message)}
                                            refs={register(valMunicipio)}
                                            value={municipio}
                                            readonly="readonly"
                                        />
                                    </div>

                                    <div className="divFormMobile">
                                        <InputTypeAndroid
                                            type="text"
                                            id="estado"
                                            name="estado"
                                            autocomplete="estado"
                                            placeholder="Estado"
                                            className="desktopInput"
                                            errorMessage={!estado && (errors.estado && errors.estado.message)}
                                            refs={register(valEstado)}
                                            readonly="readonly"
                                            value={estado}
                                        />
                                    </div>

                                    <div className="divFormMobile">
                                        <InputTypeAndroid
                                            type="text"
                                            id="ciudad"
                                            name="ciudad"
                                            autocomplete="ciudad"
                                            placeholder="Ciudad"
                                            className="desktopInput"
                                            errorMessage={!ciudad && (errors.ciudad && errors.ciudad.message)}
                                            refs={register(valCiudad)}
                                            readonly="readonly"
                                            value={ciudad}
                                        />
                                    </div>


                                    <div className="divFormMobile">
                                        <div className="subCampo">
                                            <p>Tiempo de residir en esta dirección</p>
                                                <div className="doble">
                                                    <div className="diaAnio">
                                                        <InputTypeAndroid
                                                            type="text"
                                                            name="anioResidencia"
                                                            id="anioResidencia"
                                                            placeholder="Años"
                                                            refs={register(valAnioRes)}
                                                            className="desktopInput labelRight"
                                                            autocomplete='anioResidencia'
                                                            setNumero={setInputAnioResidencia}
                                                            // value={inputAnioResidencia}
                                                            numero={inputAnioResidencia}
                                                            errorMessage={errors.anioResidencia && errors.anioResidencia.message}
                                                            pattern={'number'}
                                                            maxLength={2}
                                                        // click={() => resetErrors('anioResidencia')}
                                                        />

                                                    </div>
                                                    <div className="diaAnio">
                                                        <InputTypeAndroid
                                                            type="text"
                                                            name="mesesResidencia"
                                                            id="mesesResidencia"
                                                            placeholder="Meses"
                                                            refs={register(valMesRes)}
                                                            className="desktopInput labelRight"
                                                            autocomplete='mesesResidencia'
                                                            setNumero={setInputMesesResidencia}
                                                            // value={inputMesesResidencia}
                                                            numero={inputMesesResidencia}
                                                            errorMessage={errors.mesesResidencia && errors.mesesResidencia.message}
                                                            pattern={'number'}
                                                            maxLength={2}
                                                            max={11}
                                                            min={1}
                                                        // click={() => resetErrors('mesesResidencia')}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>


                                </>    
                                
                                <div className="boxBtnSolicitar marginBottom30">
                                    <button className="btnSolicitar"> Continuar</button>
                                </div>
                            </form>
                            </div>
                        </div>
                    </div>
                </div>
            }
            {showModalErr &&
                <ModalError
                    errorCode={errorCode}
                    section={sectionActive}
                    message={messageResponse}
                    handleClose={handleCloseErr}
                />
            }
        </>
    )
}